// extracted by mini-css-extract-plugin
export default {"input":"styles_input__Dkcwg","label":"styles_label__TlFAu","error":"styles_error__X+O5p","errorText":"styles_errorText__D3Pox"};